<div [formGroup]="form">
  <div class="form-spacing">
    <div class="column">
      <label class="label">{{ 'pre-employment.selfservice.declaration-date.label' | translate }}</label>
      <p class="text-dark">{{ form.get('createdAt')?.value | date: 'dd/MM/yyyy' }}</p>
    </div>

    <div class="column">
      <p class="text-dark" [innerHTML]="'selfservice-request.tax-relief.relief-acceptance.declaration' | translate"></p>
    </div>

    <ng-container *ngIf="showIncomeSection">
      <div class="column">
        <div class="row gap-small">
          <p-checkbox
            inputId="commerce-incomeAcceptance"
            formControlName="incomeAcceptance"
            [binary]="true"
          ></p-checkbox>
          <label for="commerce-incomeAcceptance" class="label">
            {{ 'selfservice-request.tax-relief.relief-acceptance.income-acceptance' | translate }}
            <span class="mr-1 text-red-500">*</span>
            <span class="cursor-pointer ml-1" [pTooltip]="reliefAcceptanceTooltip" tooltipPosition="right">
              <i class="pi pi-question-circle"></i>
            </span>
            <ng-template #reliefAcceptanceTooltip>
              <span [innerHTML]="'selfservice-request.tax-relief.relief-acceptance.help' | translate"></span>
            </ng-template>
          </label>
        </div>
        <small
          class="text-red-500"
          *ngIf="form.get('incomeAcceptance')?.invalid && form.get('incomeAcceptance')?.touched"
        >
          {{ 'selfservice-request.tax-relief.relief-acceptance.income-acceptance.error' | translate }}
        </small>
      </div>

      <div class="column" *ngIf="form.get('incomeAcceptance')?.value">
        <p-inputNumber
          inputId="commerce-income"
          formControlName="income"
          mode="currency"
          currency="EUR"
          locale="it-IT"
          [min]="0"
          class="full-width"
          placeholder="{{ 'selfservice-request.employment-history.input.placeholder' | translate }}"
        ></p-inputNumber>
        <small class="text-red-500" *ngIf="form.get('income')?.invalid && form.get('income')?.touched">
          {{ 'selfservice-request.tax-relief.relief-acceptance.income.error' | translate }}
        </small>
      </div>

      <div class="column">
        <div class="row gap-small">
          <p-checkbox
            inputId="commerce-alreadyTaxedSubstituteTaxAcceptance"
            formControlName="alreadyTaxedSubstituteTaxAcceptance"
            [binary]="true"
          ></p-checkbox>
          <label for="commerce-alreadyTaxedSubstituteTaxAcceptance" class="label">
            {{ 'selfservice-request.tax-relief.substitute-tax-amount.label' | translate }}
            <span class="mr-1 text-red-500">*</span>
            <span class="cursor-pointer ml-1" [pTooltip]="substituteTaxAcceptanceTooltip" tooltipPosition="right">
              <i class="pi pi-question-circle"></i>
            </span>
            <ng-template #substituteTaxAcceptanceTooltip>
              <span [innerHTML]="'selfservice-request.tax-relief.substitute-tax-amount.help' | translate"></span>
            </ng-template>
          </label>
        </div>
        <small
          class="text-red-500"
          *ngIf="
            form.get('alreadyTaxedSubstituteTaxAcceptance')?.invalid &&
            form.get('alreadyTaxedSubstituteTaxAcceptance')?.touched
          "
        >
          {{ 'selfservice-request.tax-relief.relief-acceptance.income-acceptance.error' | translate }}
        </small>
      </div>

      <div class="column" *ngIf="form.get('alreadyTaxedSubstituteTaxAcceptance')?.value">
        <p-inputNumber
          inputId="commerce-alreadyTaxedSubstituteTaxAmount"
          formControlName="alreadyTaxedSubstituteTaxAmount"
          mode="currency"
          currency="EUR"
          locale="it-IT"
          [min]="0"
          class="full-width"
          placeholder="{{ 'selfservice-request.employment-history.input.placeholder' | translate }}"
        ></p-inputNumber>
        <small
          class="text-red-500"
          *ngIf="
            form.get('alreadyTaxedSubstituteTaxAmount')?.invalid && form.get('alreadyTaxedSubstituteTaxAmount')?.touched
          "
        >
          {{ 'selfservice-request.tax-relief.relief-acceptance.income.error' | translate }}
        </small>
      </div>
    </ng-container>

    <div class="column">
      <div class="row gap-small">
        <p-checkbox inputId="commerce-reliefAcceptance" formControlName="reliefAcceptance" [binary]="true"></p-checkbox>
        <label for="commerce-reliefAcceptance" class="label">
          {{ 'selfservice-request.tax-relief.relief-acceptance.relief-acceptance' | translate }}
        </label>
      </div>
    </div>

    <div class="column">
      <div class="row gap-small">
        <p-checkbox
          inputId="commerce-nightOrHolidayWorkAcceptance"
          formControlName="nightOrHolidayWorkAcceptance"
          [binary]="true"
        ></p-checkbox>
        <label for="commerce-nightOrHolidayWorkAcceptance" class="label">
          {{ 'selfservice-request.tax-relief.relief-acceptance.night-or-holiday-work-acceptance' | translate }}
        </label>
      </div>
    </div>

    <div class="column">
      <div class="row gap-small">
        <p-checkbox inputId="commerce-acceptance" formControlName="acceptance" [binary]="true"></p-checkbox>
        <label for="commerce-acceptance" class="label">
          {{ 'selfservice-request.tax-relief.relief-acceptance.acceptance' | translate }}
          <span class="mr-1 text-red-500">*</span>
        </label>
      </div>
    </div>

    <div class="column">
      <label for="commerce-identityCardAttachments" class="label">
        {{ 'selfservice-request.tax-relief.relief-acceptance.identity-document' | translate }}
        <span class="mr-1 text-red-500">*</span>
      </label>

      <div *ngFor="let attachment of identityCardAttachments" class="row gap-small">
        <a [href]="attachment.presignedUrl" target="_blank" rel="noopener noreferrer">
          {{ getAttachmentName(attachment) }}
        </a>
      </div>

      <p-fileupload
        id="commerce-identityCardAttachments"
        mode="advanced"
        [multiple]="false"
        [auto]="false"
        [showUploadButton]="false"
        [showCancelButton]="false"
        chooseLabel="Seleziona file"
        [maxFileSize]="10000000"
        accept=".pdf,.jpg,.jpeg,.png"
        (onSelect)="onIdentityCardSelect($event)"
        (onRemove)="onIdentityCardRemove()"
        (onClear)="onIdentityCardRemove()"
        [disabled]="isUploading || form.disabled || hasIdentityCardAttachment"
        class="full-width"
      ></p-fileupload>

      <small class="text-red-500" *ngIf="uploadError">
        {{ 'selfservice-request.tax-relief.relief-acceptance.identity-document.error' | translate }}
      </small>
    </div>
  </div>
</div>
